<template>
  <div id="app">
    <!-- 提示页面 -->
    <app-tips 
    :tipInfo="tipInfo" 
    :btnshow="btnshow"
    :btnreload="btnreload"
    :btnpay="btnpay"
    :machineId="machineId"
    @tipShow="tipShow" 
    @countinuePay="countinuePay"
    v-show="tipshow"></app-tips>
    <questionnaire v-if="question" @answerInfo="answerInfo"></questionnaire>
   <!-- Mqtt确认货机是否在线-->
   <!-- 进入页面遮罩 -->
   <app-machine-alive  v-if="machine_alive" @machineStatus="machineStatus"></app-machine-alive>
   <app-mqtt :imei="imei" @machineStatus="machineStatus" ref="mychild"></app-mqtt>
   <!-- 头部-->
   <app-header v-if="head" :headInfo="headInfo" :shopInfo="shopInfo"></app-header>
   <!-- 导航 -->
   <app-nav :commentNum="commentNum" :machineId = "machineId"   :pickup = "pickup"></app-nav> 
   <!-- 货机状态 -->
   <app-m-status v-if="machinestatus" :mqttShow="mqttShow"></app-m-status>
   <!-- 商户状态 -->
   <app-check-page v-if="checkPage" :message="checkMessage"></app-check-page>
   <!-- 内容 -->
   <keep-alive>
      <router-view 
      @selectGoods="selectGoodsPay" 
      @showTip="showTip" 
      @showMessage="showMessage"
      @chooseGoods = "handleChooseGoods"
      :machineId = "machineId"
      :cartType = "cartType"
      :shopInfo = "shopInfo"
      :bsoll = "bsoll"
      :c_num = "c_num"
      :lock="lock"
      :lock_times="lock_times"
      :head="head"
      v-if="multi_page"
      ></router-view>
   </keep-alive>
   <!-- 确认订单 -->
  <order-page 
    v-if="order_page"
    :orderInfo="orderInfo"
    :machineId="machineId"
    :show_back = "multi_page"
    :source="source"
    :showPayBtn="showPayBtn"
    :lock="lock"
    :lock_times="lock_times"
    :freight_way_type="freight_way_type"
    @confirm="handleConfirm"
    @back="handleBack"
    @showMessages="showMessage"
  ></order-page>
  <!-- 购物车支付页面 -->
  <pay-page
    v-if="pay_page"
    :cartOrderInfo="cartOrderInfo"
    :machineId="machineId"
    :show_back = "multi_page"
    :source="source"
    :showPayBtn="showPayBtn"
    :lock="lock"
    :lock_times="lock_times"
    @confirm="handleConfirm"
    @back="handleBack"
    @showMessages="showMessage"
  ></pay-page>
  </div>
</template>

<script>
import Mqtt from './components/Mqtt/Mqtt'
import Header from './components/Header/Header'
import Nav from './components/Nav/Nav'
import machinestatus from './components/machinestatus/machinestatus'
import checkPage from './components/checkPage/checkPage'
import Tips from './components/tips/Tips'
import Questionnaire from './components/questionnaire/Questionnaire'
import MachineAlive from './components/tips/MachineAlive'
import orderPage from './components/orderPage/orderPage'
import payPage from './components/payPage/payPage'
export default {
  name: 'App',
  components:{
      "app-mqtt":Mqtt,
      "app-header":Header,
      "app-nav":Nav,
      "app-m-status":machinestatus,
      "app-check-page":checkPage,
      "app-tips":Tips,
      "questionnaire": Questionnaire,
      "app-machine-alive":MachineAlive,
      "order-page":orderPage,
      "pay-page":payPage,
  },
  data(){
    return{
      head:false,
      poiInfo:{},
      commentNum:0,
      headInfo:{},//头部轮播图信息
      orderInfo:{
        No:'',
        capacity:'',
        goods_id:'',
        machine_id:'',
        merchantId:'',
        goods:{
          goodsId:'',
          goodsImage:'',
          goodsName:'',
          goodsPrice:'',
          goodsUnit:''
        }
      },//确认订单信息
      cartOrderInfo:{},//购物车订单信息
      putOrderInfo:{
            user_id:"",
            open_id:"",
            source: 0,
            merchant_id:"",
            operation_id:"",
            machine_id:"",
            check:true,
            goods_list:[]
      },//提交的订单信息
      mqttShow: '',
      shopInfo:{},//货机信息
      tipInfo:"",
      cartType:0, //购物车是否启用  1启用   0关闭
      app_id: '', //微信小程序id
      tipshow:false,
      btnshow:true,
      btnreload:false,
      btnpay:false,
      tipReload:false,//tips页面是否刷新页面
      machine_alive:true,
      machinestatus:false,
      commentNum:0,
      source:0,//入口  微信 WeiXIN  支付宝 Alipay
      multi_page:true,//选择商品 true为开启  false为关闭  与order_page 配合使用
      order_page:false,  //确认订单页面 扫描货道 true为开启  false为关闭   与multi_page 配合使用
      pay_success_page:false,  //支付成功页面
      pay_page:false,   //同上
      pay_fail_page:false,  //支付失败页面
      pay_await_page:false,  //支付查询页面
      goods_push_page:false,  //等待出货页面
      goods_push_success_page:false,  //出货成功页面
      goods_push_fail_page:false,  //出货失败页面
      machineId:"",//货机id
      imei:"",
      freight_way:"", //货道号
      freight_way_type: 0, //货道状态
      aisle_code:"", //用户code
      open_id:"",//用户openid
      user_id:"",//用户userid
      state:"",//跳转后带的参数
      bankRequestNum:"",  //银行流水号
      orderNum:"",  //订单号
      requestNum:"",  //请求编号
      res:{},
      showPayBtn:true,
      pay_url: '', //支付url
      bsoll:false, //商品滚动
      putUserInfo:{
        source: '',
        code: '',
        app_id: ''
      }, //提交获取用户openid
      checkPage: false,
      checkMessage: '',
      question: false, //调查问卷
      pickup: '0', //是否显示取货码功能  0不显示  1显示
      c_num: '', //c端表示码
      lock: '0', //是否开启库存锁定  0不锁定  1开启锁定
      lock_times: 60, //开始锁定后的锁定库存的时间
    }
  },

  created(){
    if(this.$route.query.machineId){
      this.machineId = this.$route.query.machineId
      // 线上测试时打开
      // if(this.machineId != 669){
      //   this.showMessage("系统正在维护，预计需要15到20分钟，给您代来不便，敬请谅解！")
      // }
    }
    // }else{
    //       //alert('获取数据错误，请您重新扫码，谢谢！');
    //       this.tipInfo = "获取数据错误，请您重新扫码，谢谢！";
    //       this.tipshow = true;
    //       this.btnshow = false;
    //       setTimeout(function(){
    //         window.opener=null;
    //         window.close();
    //       },3000)
    //       return;
    // }
    if(this.$route.query.freight_way){
        this.freight_way = this.$route.query.freight_way
        this.freight_way_type = 1;
    }
    
    //检查商户信息
    fetch("https://home.hrcc8.com/home/api/c/checkMerchant?machineId="+this.machineId)
    .then(res => {
      return res.json()
    })
    .then(response =>{
      if(response.code == 10000){
        this.checkMessage = response.msg
        this.checkPage = true
        this.multi_page = false
      }
    })
    

    //识别扫描入口
    var ua = window.navigator.userAgent.toLowerCase();
    if ( ua.match(/MicroMessenger/i) == 'micromessenger' ) {  
          //判断是不是微信
          this.source = 1;
          //重定向获取用户code的链接
          //调用
          // if(this.$route.query.code){
          //     this.aisle_code = this.$route.query.code
          //     //alert(this.aisle_code)
          // }
          // if(this.$route.query.state){
          //     this.state = this.$route.query.state
          //     let a = this.state.split(".")
          //     this.machineId = a[0]
          //     this.freight_way = a[1] 
          // }
          // if(this.$route.query.machineId){
          //     this.state = this.$route.query.machineId+"."
          // }
          // if(this.$route.query.freight_way){
          //     this.state = this.state +this.$route.query.freight_way
          // }
          
          // //使用客户公众号的时候在这里调用获取商户公众号appId的api 
          // fetch("https://home.hrcc8.com/home/api/c/GetWechatInfo/?machineId="+this.machineId)
          // .then(res => {
          //   return res.json()
          // })
          // .then(response =>{
          //   if(response.code == 20000){
          //     this.app_id = response.data.app_id
          //       //alert(this.app_id)
          //       if(this.aisle_code == ""){
          //           window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.app_id + "&redirect_uri=https%3A%2F%2Fhomeshop.hrcc8.com%2F%3FmachineId%3D"+this.machineId+"%26freight_way%3D"+this.freight_way+"&response_type=code&scope=snsapi_base&state="+this.state+"#wechat_redirect";
          //       }

          //   }else{
          //     alert(response.msg)
          //   }
          // })

    } else if (ua.match(/AlipayClient/i) == 'alipayclient') {
        //判断是不是支付宝
        this.source = 2;
          // if(this.$route.query.auth_code){
          //     this.aisle_code = this.$route.query.auth_code
          // }
          // if(this.$route.query.state){
          //     this.state = this.$route.query.state
          //     let a = this.state.split(".")
          //     this.machineId = a[0]
          //     this.freight_way = a[1] 
          // }
          // if(this.$route.query.machineId){
          //     this.state = this.$route.query.machineId+"."
          // }
          // if(this.$route.query.freight_way){
          //     this.state = this.state +this.$route.query.freight_way
          // }
          //设定app_id
          // this.app_id = '2021002162660079'
          // //alert(this.app_id)
          // if(this.aisle_code == ""){
          //   window.location.href = "https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021002162660079&scope=auth_base&redirect_uri=https%3A%2F%2Fhomeshop.hrcc8.com%2F%3FmachineId%3D"+this.machineId+"%26freight_way%3D"+this.freight_way+"&state="+this.state;

          //   return;
          // }
    } else {
        //哪个都不是退出
        // alert('请使用微信或支付宝扫码，谢谢！');
        this.tipInfo = "请使用微信或支付宝扫码，谢谢！";
        this.tipshow = true;
        this.btnshow = false;
        setTimeout(function(){
          window.opener=null;
          window.close();
        },3000)
        return ;
    }
    
    //生成C端标识码
    let a = Date.now();
    let b = '';
    for(var i=0;i<10;i++){
      b += Math.floor(Math.random()*10)
    }
    this.c_num = a +'_'+ b
    console.log(this.c_num)
    // if (this.aisle_code != "" && this.source == 1 && this.open_id == "") {
    //       this.putUserInfo.code = this.aisle_code
    //       this.putUserInfo.source = this.source
    //       this.putUserInfo.machineId = this.machineId
    //       //alert("putUserInfo.code"+this.putUserInfo.code)
    //       //alert("putUserInfo.source"+this.putUserInfo.source)
          
    //       //alert("putUserInfo.machineId"+this.putUserInfo.machineId)
    //     this.axios.post(   //请求方式
    //       "https://home.hrcc8.com/home/api/c/user",  //接口地址
    //       this.putUserInfo
    //     )    //传递参数 
    //     .then(response =>{
    //       //alert(response.data.code)
    //         if(response.data.code == 20000){
    //           // // 解决刷新code不变的问题
    //           // if(response.data.errcode){
    //           //   window.location.href = "http://homeshop.hrcc8.com/?machineId="+this.machineId+"&freight_way="+this.freight_way
    //           // } 
    //           //获取openid 和 userid
    //           this.open_id = response.data.data.openid
    //           this.user_id = response.data.data.userId
    //           //alert(this.open_id)
    //           //alert(this.user_id)
    //         }else{
    //           //alert(response.data.msg)
    //           window.location.href = "http://homeshop.hrcc8.com/?machineId="+this.machineId+"&freight_way="+this.freight_way
    //           //this.tipInfo = "系统遇到问题，请您刷新重试，如果多次刷新仍未成功请向机主反馈，谢谢！  （错误信息："+response.data.msg+")"
    //           //this.tipInfo = error;
    //           //this.tipshow = true
    //         }
    //     })
    //     .catch((error) => {
    //         //console.log(error)
    //         //alert("非常抱歉，出现系统内部错误！")
    //         this.tipInfo = "非常抱歉，系统出现内部错误！"+error;
    //         this.tipshow = true;
    //     })
    // }

    
    //头部图片
    fetch("https://home.hrcc8.com/home/api/c/header?machineId="+this.machineId)
      .then(res => {
        return res.json()
      })
      .then(response =>{
        if(response.code == 20000){
          if(response.data != [] || response.data != null){
            this.headInfo = response.data
            this.head = true
          } else {
            this.head = false
          }
          
        }
      })


    //获取商户信息
    fetch("https://home.hrcc8.com/home/api/c/merchant_shop/?machineId="+this.machineId)
      .then(res => {
        return res.json()
      })
      .then(response =>{
        if(response.code == 20000){ 
          if(response.data.shopName == undefined){
            response.data.shopName = "星星的店"
          }else{
            if(response.data.shopName == ""){
                response.data.shopName = "星星的店"
            }
            
            //判断商户是否配置了支付账户信息，如果没有配置则提示客户
          }
          this.shopInfo = response.data
          this.pickup = response.data.pickup
          console.log(this.shopInfo)
          this.imei = response.data.imei  //获取设备的imei
          //调用mqtt获取设备状态
          //if(this.aisle_code != ""){
            if(this.imei != ''){
              console.log('传入的imei'+this.imei)
              this.$refs.mychild.testOnLine(this.imei)
            }
          //}
          //console.log(this.imei)
          //根据商户设定来开启0或关闭购物车1
          this.cartType = response.data.is_cart
          
          //判断是否需要显示调查问卷
          if(response.data.question != undefined)
          {
            if(response.data.question == '1'){
                this.question = true
            }else{
                this.question = false
            }
            
          }
          //判断是否有app头标题信息
          if(response.data.title == undefined)
          {
            document.title = "恒瑞成";
          }else{
            document.title = response.data.title;
          }
          //获取商户设置信息
          this.lock = response.data.lock
          this.lock_times = response.data.lock_times
          console.log(this.lock)
          console.log(this.lock_times)
        }
      })

      //如果是单货道扫码
      if(this.freight_way != ""){
        //访问单货道商品接口然后将相关信息推送到页面
        fetch("https://home.hrcc8.com/home/api/c/getGoodsFreight?machineId="+this.machineId+"&freight_way="+this.freight_way)
        .then(res => {
          return res.json()
        })
        .then(response =>{
          if(response.code == 0){ 
            this.orderInfo = response.data
            //添加货道信息
            let info = {};
            let p_info = Array();
                p_info[0]='{"No":'+this.orderInfo['No']+',"count":1,"goods_id":'+this.orderInfo['goods_id']+',"price":'+this.orderInfo['price']+'}';
                // p_info[0]={
                //       "No":this.orderInfo['No'],
                //       "count":1,
                //       "goods_id":this.orderInfo['goods_id'],
                //       "price":this.orderInfo['price']
                //     };
            info['total_price'] = this.orderInfo['price'];
            info['total_count'] = 1;
            info['No_list'] = this.orderInfo['No'];
            info['machine_id'] = this.orderInfo['machine_id'];
            info['merchant_id'] = this.orderInfo['merchant_id'];
            info['operation_id'] = this.orderInfo['operation_id'];
            info['goods'] = '['+p_info+']';
            this.cartOrderInfo = info;
            //console.log(this.cartOrderInfo)
          }else if(response.code == 404){
            this.machineDown()
          }else if(response.code == 405){
            this.machineOver()
          }else{
            //alert("获取单货道数据出现错误！")
            this.tipInfo = "获取单货道数据出现错误！";
            this.tipshow = true;
            this.btnshow = false;
            setTimeout(function(){
              window.opener=null;
              window.close();
            },3000)
            return;
          }
        })

        this.multi_page = false
        this.order_page = true
    }
    
  },
  methods: {
    answerInfo(info){
      if(info['first'] == "" || info['third'] == ""){
        alert("问卷的第一题和第三题必填。")
        return
      }
      //console.log(info)
      this.putOrderInfo.answer = '{"first":"'+info['first']+'","second":"'+info['second']+'","third":"'+info['third']+'"}'
      //console.log(this.putOrderInfo)
      this.question = false
    },
    showTip(info){
      //console.log(info)
      this.tipInfo = info
      this.tipshow = true
    },
    showMessage(info){
      this.tipInfo = info
      this.tipshow = true
      this.btnshow = false
    },
    tipShow(){
      this.tipshow = false
      if(this.tipReload){
        //刷新页面
        location.reload();
      }
    },
    countinuePay(){
      console.log('continuePay');
      this.tipshow = false;
      this.putOrderInfo.check = false;
      //this.handleConfirm();
    },
    machineDown: function(){
      //alert("当前设备已离线！");
      this.tipInfo = "当前设备已离线！";
      this.tipshow = true;
      this.btnshow = false;
      setTimeout(function(){
        window.opener=null;
        window.close();
      },3000)
      return
    },
    machineOver: function(){
      //alert("当前设备已过期！");
      this.tipInfo = "当前设备已过期！";
      this.tipshow = true;
      this.btnshow = false;
      setTimeout(function(){
        window.opener=null;
        window.close();
      },3000)
      return
    },
    handleChooseGoods: function(that){ //不带购物车的时候获取订单数据
      this.orderInfo = that
      console.log(this.orderInfo)
      //添加货道信息
      let info = {};
      let p_info = Array();
          p_info[0]='{"No":'+that['No']+',"count":1,"goods_id":'+that['goods_id']+',"price":'+that['price']+'}';
          // p_info[0]={
          //       "No":that['No'],
          //       "count":1,
          //       "goods_id":that['goods_id'],
          //       "price":that['price']
          //     };
      info['total_price'] = that['price'];
      info['total_count'] = 1;
      info['No_list'] = that['No'];
      info['machine_id'] = that['machine_id'];
      info['merchant_id'] = that['merchant_id'];
      info['operation_id'] = that['operation_id'];
      info['goods'] = '['+p_info+']';
      info['goods_id'] = that['goods_id'];
      this.cartOrderInfo = info;
      //console.log(this.cartOrderInfo)

      this.multi_page = false
      this.order_page = true
    },
    handleConfirm: function(){
      //隐藏支付按钮
      this.showPayBtn = false
      // 锁库存时
      if(this.lock == '1' && this.freight_way == ""){
          //将信息插入orderInfo中
          var goods_info
          if(this.cartType == 1){
            goods_info = {"machine_id":this.machineId,"c_num":this.c_num,"type":1,"goods":this.cartOrderInfo.goods}
          }
          if(this.cartType == 0){
            goods_info = {"machine_id":this.machineId,"c_num":this.c_num,"type":0,"goods":this.cartOrderInfo.No_list}
          }
          //先确认一下锁定的库存
          const check_url = "https://home.hrcc8.com/home/api/c/check_goods" //验证锁定库存是否正常
          this.axios.post(   //请求方式
            check_url,  //接口地址
            goods_info
            )    //传递参数 
            .then(res=>{
              console.log(res)
                if(res.data.code === 20000){
                    this.pay()
                }else{
                    this.tipInfo = res.data.msg;
                    this.tipshow = true;
                }
            }) 
      }

      //不锁库存
      if(this.lock == '0' || this.freight_way != ""){
          this.pay()
      }
    },
    pay(){
        //将信息插入orderInfo中
        if(this.cartType == 1){
          this.putOrderInfo.user_id = this.user_id
          this.putOrderInfo.open_id = this.open_id
          this.putOrderInfo.source = this.source
          this.putOrderInfo.merchant_id = this.cartOrderInfo.merchant_id
          this.putOrderInfo.operation_id = this.cartOrderInfo.operation_id 
          this.putOrderInfo.machine_id = this.cartOrderInfo.machine_id
          this.putOrderInfo.goods_list = this.cartOrderInfo.goods
          var url = "https://home.hrcc8.com/home/api/c/orderCart" //下单接口
        }
        if(this.cartType == 0){
          this.putOrderInfo.goods_id = this.cartOrderInfo.goods_id
          this.putOrderInfo.machine_id =  this.cartOrderInfo.machine_id
          this.putOrderInfo.No = this.cartOrderInfo.No_list
          this.putOrderInfo.user_id = this.user_id
          this.putOrderInfo.open_id = this.open_id
          this.putOrderInfo.merchant_id = this.cartOrderInfo.merchant_id
          this.putOrderInfo.source = this.source
          this.putOrderInfo.operation_id = this.cartOrderInfo.operation_id
          var url = "https://home.hrcc8.com/home/api/c/order" //下单接口
        }
        console.log(this.putOrderInfo)
        this.axios.post(   //请求方式
        url,  //接口地址
        this.putOrderInfo
        )    //传递参数 
        .then(response =>{
            if(response.data.code == 20000){
              var a = document.createElement("a");
                  a.setAttribute("href", response.data.data.url);
                  // a.setAttribute("target", "_blank");
                  a.click();
            }else{
              this.tipInfo = response.data.msg;
              //this.tipInfo = error;
              this.tipshow = true;
            }
        })
        .catch((error) => {
            //console.log(error)
            //alert("非常抱歉，出现系统内部错误！")
            this.tipInfo = "非常抱歉，系统出现内部错误！"+error;
            //this.tipInfo = error;
            this.tipshow = true;
            //显示支付按钮
            this.showPayBtn = true
        })
    },
    handleBack:function(){
      
      //锁库存的时候
      if(this.lock == '1'){  
          let goods = ''
          if(this.cartType == 1){
              goods = {"machine_id":this.machineId,"c_num":this.c_num,"type":1,"goods":this.cartOrderInfo.goods}
          }
          if(this.cartType == 0){
              goods = {"machine_id":this.machineId,"c_num":this.c_num,"type":0,"goods":this.orderInfo.No}
          }
          console.log(goods)
          let url = "https://home.hrcc8.com/home/api/c/back_del_goods" //验证锁定库存是否正常
          this.axios.post(   //请求方式
          url,  //接口地址
          goods
          )    //传递参数 
          .then(res=>{
                this.order_page = false
                this.pay_page = false
                this.multi_page = true
                this.bsoll = true
                this.showPayBtn = true
                //location.reload()
                location.replace('https://homeshop.hrcc8.com/?machineId=' + this.machineId)
                //location.replace('http://192.168.1.246:8081/?machineId=' + this.machineId)
          })
      }
      // 不锁库存的时候
      if(this.lock == '0'){
          this.order_page = false
          this.pay_page = false
          this.multi_page = true
          this.bsoll = true
          this.showPayBtn = true
          //location.reload()
          location.replace('https://homeshop.hrcc8.com/?machineId=' + this.machineId)
          //location.replace('http://192.168.1.246:8081/?machineId=' + this.machineId)
      }
    },
    fshowPayBtn: function(){
      this.showPayBtn = true
    },
    selectGoodsPay: function(that){  //带购物车的时候获取订单数据
      console.log(that);
      let info = {};
      let p_info = Array();
      let total_price = 0;
      let total_count = 0;
      let No_list = "";
      let machine_id = "";
      let merchant_id = "";
      let operation_id = "";
      for(let i in that){
        //总价格
        let goods_price = 0;
        goods_price = Number(that[i]['price']) *Number(that[i]['count']);
        total_price += goods_price;
        //总商品数量
        total_count += that[i]['count'];
        //货道列表
        if(i ==0){
          No_list = that[i]['No'];
        }else{
          No_list = No_list +','+ that[i]['No'];
        }
        //货机id
        machine_id = that[i]['machine_id'];
        //商户id
        merchant_id = that[i]['merchant_id'];
        //操作员id
        operation_id = that[i]['operation_id'];
        p_info[i] ='{"No":'+that[i]['No']+',"count":'+that[i]['count']+',"goods_id":'+that[i]['goods_id']+',"price":'+that[i]['price']+'}';
        // p_info[i]={
        //             'No':that[i]['No'],
        //             'count':that[i]['count'],
        //             'goods_id':that[i]['goods_id'],
        //             'price':that[i]['price']
        //           };
      }
      total_price = Math.round(total_price*100)/100   //总价格四舍五入保留2位小数
      info['total_price'] = total_price;
      info['total_count'] = total_count;
      info['No_list'] = No_list;
      info['machine_id'] = machine_id;
      info['merchant_id'] = merchant_id;
      info['operation_id'] = operation_id;
      info['goods'] = '['+p_info+']';
      this.cartOrderInfo = info;
      console.log(info)
      this.multi_page = false
      this.pay_page = true
    },
    machineStatus: function(status,msg){
      if(status == "on"){
        this.machine_alive = false;
      }
      if(status == "off"){
        this.multi_page = false;
        this.machinestatus = true;
        this.mqttShow = msg;
        this.machine_alive = false;
      }
    }


  }
}
</script>

<style >
  body{
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue